var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex flex-column justify-content-center align-items-center"},[_c('v-img',{attrs:{"src":_setup.computedImageUrl,"contain":true,"alt":"","max-height":"16rem","max-width":"16rem"}}),(_vm.chemical?.sid)?_c(_setup.ChemLinks,{attrs:{"sid":_vm.chemical?.sid}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }